var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.$t('message.preview'))+": "),_c('div',{staticClass:"marquee",attrs:{"id":"marquee"}},[_c('span',{staticClass:"flix-html-strong flix-text-success"},[_vm._v(" "+_vm._s(_vm.dates)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }